import httpClient, { SEARCH_TIMEOUT_MS } from "./httpClient";

export const trademarkApi = {
  /**
   * @param {Object} payload search query
   * @param {Function} [onRetry] called with { attempt, of, delay } so the UI
   *   can tell the user we are retrying instead of appearing frozen
   */
  search: (payload, onRetry) =>
    httpClient.post("/trademarks/search", payload, {
      timeout: SEARCH_TIMEOUT_MS,
      onRetry,
    }),

  /**
   * Full per-mark records (goods & services, owners, representative,
   * history…) for up to 25 application numbers. Slower than a search row,
   * so it gets its own timeout and a single retry.
   */
  getDetails: (applicationNumbers, source = "euipo") =>
    httpClient.post(
      "/trademarks/details",
      { source, applicationNumbers },
      { timeout: 30000, maxRetries: 1 },
    ),

  /**
   * OCR for "search by logo": send a (resized) logo image, get back the
   * words written in it. One vision-model call, so it gets its own timeout
   * and no automatic retry.
   */
  extractLogoText: (payload) =>
    httpClient.post("/trademarks/extract-logo-text", payload, {
      timeout: 45000,
      maxRetries: 1,
    }),

  getHistory: (page = 1, limit = 10) =>
    httpClient.get("/trademarks/history", { params: { page, limit } }),

  getHistoryItem: (id) => httpClient.get(`/trademarks/history/${id}`),

  deleteHistoryItem: (id) => httpClient.delete(`/trademarks/history/${id}`),

  deleteAllHistory: () => httpClient.delete("/trademarks/history"),
};

export const euipoApi = {
  status: () => httpClient.get("/euipo/status", { maxRetries: 1 }),
  verify: () => httpClient.post("/euipo/verify", {}, { maxRetries: 1 }),
};

export const systemApi = {
  health: () => httpClient.get("/health", { maxRetries: 1 }),
};
